import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"width":"100%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pie_chart = _resolveComponent("pie-chart")!
  const _component_doughnut_chart = _resolveComponent("doughnut-chart")!
  const _component_line_chart = _resolveComponent("line-chart")!
  const _component_bar_chart = _resolveComponent("bar-chart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.data)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.chartType === 'pie')
            ? (_openBlock(), _createBlock(_component_pie_chart, {
                key: 0,
                data: _ctx.data,
                options: _ctx.options,
                width: _ctx.$vuetify.display.xs ? 160 : 200,
                height: _ctx.$vuetify.display.xs ? 112 : 140,
                class: "d-flex justify-center"
              }, null, 8, ["data", "options", "width", "height"]))
            : (_ctx.chartType === 'doughnut')
              ? (_openBlock(), _createBlock(_component_doughnut_chart, {
                  key: 1,
                  data: _ctx.data,
                  options: _ctx.options,
                  width: _ctx.$vuetify.display.xs ? 160 : 200,
                  height: _ctx.$vuetify.display.xs ? 112 : 140,
                  class: "d-flex justify-center"
                }, null, 8, ["data", "options", "width", "height"]))
              : (_ctx.chartType === 'line')
                ? (_openBlock(), _createBlock(_component_line_chart, {
                    key: 2,
                    data: _ctx.data,
                    options: _ctx.options,
                    width: _ctx.$vuetify.display.xs ? 160 : 200,
                    height: _ctx.$vuetify.display.xs ? 112 : 140,
                    class: "d-flex justify-center"
                  }, null, 8, ["data", "options", "width", "height"]))
                : (_openBlock(), _createBlock(_component_bar_chart, {
                    key: 3,
                    data: _ctx.data,
                    options: _ctx.options,
                    width: _ctx.$vuetify.display.xs ? 160 : 200,
                    height: _ctx.$vuetify.display.xs ? 112 : 140,
                    class: "d-flex justify-center"
                  }, null, 8, ["data", "options", "width", "height"]))
        ], 64))
      : _createCommentVNode("", true)
  ]))
}